const FREE = 'free';
const PARTNER = 'partner';
const UNLIMITED = 'unlimited';
const ACCOUNTS = [
  {name: "Free Trial",      type: FREE},
  {name: "SEMRush Partner", type: PARTNER},
  {name: "Unlimited",       type: UNLIMITED}
];

const ACCOUNT_TYPES = ACCOUNTS.map((account, i) => account.type );